import { SelectInput } from "../UI/Select";
import { useTranslation } from "react-i18next";

const CampusSelect = ({ optionList, multiple = false }) => {
  const { t } = useTranslation("form");
  return (
    <SelectInput
      label={multiple ? t("campusMultiple") : t("campus")}
      placeholder={t("campus")}
      id="campus_id"
      autoComplete="campus"
      required={true}
      multiple={multiple}
      helperText={null}
      optionList={optionList}
    />
  );
};
export default CampusSelect;